import InputBox from "../../../../Component/DigitalMarketing/Forms/InputBox";
import InputSelect from "../../../../Component/DigitalMarketing/Forms/InputSelect";

export const SourceOption = [
{ id: "facebook", status: "Facebook" },
{ id: "instagram", status: "Instagram" },
{ id: "direct_call", status:  "Direct Call" },
{ id: "qr_code", status: "QR Code" },
                  ];
// export const SourceLabel = [
// {tag:InputSelect,label:'Source Name',option:SourceOption,key_name:'remarks',ids:'id',list_name:'status'},
// {tag:InputBox,label:'Remarks',type:'text',placeholder:'Enter your remarks',key_name:'remarks'},
// ]
export const SourceLabel = [
{tag:InputBox,label:'Facebook',type:'text',key_name:'facebook',style:'input-grey-copy'},
{tag:InputBox,label:'Instagram',type:'text',key_name:'instagram',style:'input-grey-copy'},
{tag:InputBox,label:'Google',type:'text',key_name:'google',style:'input-grey-copy'},
{tag:InputBox,label:'Twitter',type:'text',key_name:'twitter',style:'input-grey-copy'},
{tag:InputBox,label:'Linkedin',type:'text',key_name:'linkedin',style:'input-grey-copy'},
{tag:InputBox,label:'Youtube',type:'text',key_name:'youtube',style:'input-grey-copy'},

]